import * as React from 'react';
import { PiralDocsInfoBarComponentProps } from '../scripts/types';

// tslint:disable-next-line:no-null-keyword
const InfoBar: React.FC<PiralDocsInfoBarComponentProps> = () => null;

export default InfoBar;
